<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import { pipeMarkupParser } from '@tools/parsers/pipeMarkupParser';
import { useQuery } from '@tanstack/vue-query';
import { polisQueries } from './polisQueries';

const props = defineProps<{ clausulenummer: number; polisnummer: string }>();

const { clausulenummer } = toRefs(props);
const { polisnummer } = toRefs(props);

const { data, isPending, isError } = useQuery({
  ...polisQueries.getClausule(clausulenummer, polisnummer),
  staleTime: 30000,
  retry: 3,
});

const clausuletekst = computed(() =>
  data.value?.data?.clausuletekst?.replace(/~/g, '').trimStart(),
);

const titel = computed(() => data.value?.data?.titel);
</script>
<template>
  <VContentBox :title="titel">
    <VSkeleton height="lg" :count="3" v-if="isPending" />
    <div v-html="pipeMarkupParser(clausuletekst)"></div>
    <VInfoBox v-if="isError" type="danger">
      Er is een fout opgetreden bij het ophalen van de clausuletekst. Probeer het later opnieuw.
    </VInfoBox>
  </VContentBox>
</template>
